import React from "react";
import { Helmet } from "react-helmet";

export type MetaDataProps = {
  title: string;
};
export const MetaData = ({ title }: MetaDataProps) => (
  <Helmet>
    <meta charSet="utf-8" />
    <title>{title}</title>
  </Helmet>
);

export default MetaData;
